<template>
  <div>
    <v-dialog v-model="showLinksDialog" persistent width="70%">
      <v-card>
        <v-toolbar color="#EEF2F6">
          <v-card-title>
            <i class="fal fa-books mr-2"></i>
            <span class="headline">Edit External Links for {{ name }}</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <button
            type="button"
            class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
            @click="close"
            :disabled="isLoading"
          >
            <i class="fal fa-times"></i>
          </button>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <draggable
              :list="links"
              @start="dragging = true"
              @end="dragging = false"
              :options="{ animation: 200, group: 'status' }"
              :element="'div'"
              v-model="links"
            >
              <v-row
                v-for="(link, index) in links"
                :key="link.key"
                align="center"
                justify="center"
              >
                <v-col cols="12" sm="12" md="1">
                  <v-icon> fal fa-arrows </v-icon>
                </v-col>
                <v-col cols="12" sm="12" md="5">
                  <v-text-field
                    v-model="link.name"
                    label="Name that will display on the list"
                    :disabled="isLoading"
                    :loading="isLoading"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="5">
                  <v-text-field
                    v-model="link.url"
                    label="Source URL"
                    :disabled="isLoading"
                    :loading="isLoading"
                    @click="toggleLinkDialog(index)"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="1">
                  <v-spacer />
                  <v-btn
                    @click="addLink"
                    small
                    dark
                    text
                    :disabled="isLoading"
                    :loading="isLoading"
                    color="success darken-3"
                  >
                    <v-icon small>fas fa-plus-circle</v-icon>
                  </v-btn>
                  <v-btn
                    @click="removeLink(index)"
                    v-if="links.length > 1"
                    small
                    dark
                    text
                    :disabled="isLoading"
                    :loading="isLoading"
                    color="error darken-3"
                  >
                    <v-icon small>fas fa-minus-circle</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </draggable>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue-grey darken-1"
            text
            @click="close"
            :disabled="isLoading"
            :loading="isLoading"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            @click="save"
            :disabled="isLoading"
            :loading="isLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-file-dialog
      :name="'Insert URL'"
      :type="'all'"
      :show-upload-dialog="showUploadDialog"
      :close-dialog="closeUploadDialog"
      v-on:showImage="updateUrl"
      :key="currentIndex"
    />
  </div>
</template>

<script>
import { forEach as _forEach, map as _map } from 'lodash-es';
import UploadFileDialog from '@/components/dialogs/UploadFileDialog';

export default {
  name: 'Links',
  components: {
    UploadFileDialog,
  },
  props: {
    isLoading: Boolean,
    name: String,
    moduleLinks: Array,
    showLinksDialog: Boolean,
    closeModal: Function,
    saveLinks: Function,
    moduleId: Number,
    toDelete: Array,
  },
  data() {
    return {
      showUploadDialog: false,
      currentIndex: null,
      curriculum: {
        name: null,
        assignedDealer: null,
        assignedSpecificDealers: null,
        is_draft: false,
      },
      dealers: [],
      specific_dealers: [],
      isChanged: false,
      defaultLinks: [
        {
          name: null,
          url: null,
        },
      ],
    };
  },

  watch: {
    showLinksDialog(val) {
      val || this.close();
    },
  },
  computed: {
    links() {
      return this.moduleLinks.length !== 0
        ? this.moduleLinks
        : this.defaultLinks;
    },
  },
  methods: {
    save() {
      if (this.moduleLinks.length == 0) {
        _forEach(_map(this.links), (link, index) => {
          this.moduleLinks.push(link);
        });
      }
      this.saveLinks();
    },
    updateUrl(item) {
      this.links[this.currentIndex].url = item.value;
    },
    toggleLinkDialog(index) {
      this.currentIndex = index;
      this.showUploadDialog = true;
    },
    addLink() {
      this.links.push({
        name: null,
        url: null,
      });
    },
    closeUploadDialog() {
      this.showUploadDialog = false;
    },
    removeLink(index) {
      if (this.links[index].id) {
        this.toDelete.push(this.links[index]);
        console.log(this.toDelete);
      }
      this.links.splice(index, 1);
    },
    close() {
      this.closeUploadDialog();
      this.closeModal();
    },
    checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    changeOrder(e) {
      this.isChanged = true;
    },
  },
};
</script>

<style scoped></style>
